import { combineReducers } from 'redux';
import makePendingReducers from '../../../oldpantheon/redux/pending/reducers/makePendingReducers';

export default combineReducers({
  ...makePendingReducers(),
});
